import { type Dayjs } from 'dayjs'

export interface MonthGrid {
  /** All visible days (incl. leading/trailing days of the neighboring months). */
  days: Dayjs[]
  gridStart: Dayjs
  gridEnd: Dayjs
}

/**
 * Builds the month grid like a file-explorer calendar: Monday-based, full
 * week rows, so the partial days of the neighboring months are shown too.
 * `gridStart`/`gridEnd` are at the same time the range for loading the events.
 */
export function buildMonthGrid(month: Dayjs): MonthGrid {
  const monthStart = month.startOf('month')
  const offset = (monthStart.day() + 6) % 7 // Mo = 0, So = 6
  const gridStart = monthStart.subtract(offset, 'day')
  const weeks = Math.ceil((offset + month.daysInMonth()) / 7)
  const days = Array.from({ length: weeks * 7 }, (_, i) => gridStart.add(i, 'day'))
  return { days, gridStart, gridEnd: days[days.length - 1] }
}

export const WEEKDAY_LABELS = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'] as const

export const dayKey = (d: Dayjs) => d.format('YYYY-MM-DD')
